const callCenter = {
  path: "/callCenter", //主体
  name: "callCenter",
  redirect: "/customerInfo",
  component: () => import("../views/callCenter/main"),
  children: [
    {
      path: "/customerInfo",
      name: "customerInfo",
      mate: {
        title: "首页"
      },
      component: () => import("../views/callCenter/customerInfo/index")
    },

    {
      path: "/detailsInfo",
      name: "detailsInfo",
      mate: {
        title: "工单系统"
      },
      component: () => import("../views/callCenter/detailsInfo/index"),
      children: [
        {
          path: "/serviceOrder",
          name: "serviceOrder",
          mate: {
            title: "服务工单"
          },
          component: () =>
            import("../views/callCenter/detailsInfo/serviceOrder/index")
        },
        {
          path: "/returnVisit",
          name: "returnVisit",
          mate: {
            title: "老干服务工单"
          },
          component: () =>
            import("../views/callCenter/detailsInfo/returnVisit/index"),
          children: [
            {
              path: "/workOrder1",
              name: "workOrder1",
              mate: {
                title: "老干工单派发"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/returnVisit/workOrder1")
            },
            {
              path: "/workOrder2",
              name: "workOrder2",
              mate: {
                title: "老干工单处理"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/returnVisit/workOrder2")
            },
            {
              path: "/workOrder3",
              name: "workOrder3",
              mate: {
                title: "老干工单回访"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/returnVisit/workOrder3")
            },
            {
              path: "/workOrder4",
              name: "workOrder4",
              mate: {
                title: "老干工单作废"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/returnVisit/workOrder4")
            },
            {
              path: "/workOrder5",
              name: "workOrder5",
              mate: {
                title: "老干工单完成"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/returnVisit/workOrder5")
            },
            {
              path: "/workOrder6",
              name: "workOrder6",
              mate: {
                title: "老干工单已作废"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/returnVisit/workOrder6")
            },
            {
              path: "/workOrder7",
              name: "workOrder7",
              mate: {
                title: "老干工单查询"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/returnVisit/workOrder7")
            }
          ]
        },
        {
          path: "/workOrderCompleted",
          name: "workOrderCompleted",
          mate: {
            title: "工单编辑"
          },
          component: () =>
            import("../views/callCenter/detailsInfo/workEdit/index")
        },{
          path: "/workEdit",
          name: "workEdit",
          mate: {
            title: "工单结束"
          },
          component: () =>
            import("../views/callCenter/detailsInfo/workOrderCompleted/index")
        },
        {
          path: "/workQuery",
          name: "workQuery",
          mate: {
            title: "工单查询"
          },
          component: () =>
            import("../views/callCenter/detailsInfo/workQuery/index")
        },
        {
          path: "/workHistorical",
          name: "workHistorical",
          mate: {
            title: "历史工单"
          },
          component: () =>
            import("../views/callCenter/detailsInfo/workHistorical/index")
        },
        {
          path: "/addReturn",
          name: "addReturn",
          mate: {
            title: "民政服务工单"
          },
          component: () =>
            import("../views/callCenter/detailsInfo/addReturn/index"),
          children: [
            {
              path: "/civilOrderXM",
              name: "civilOrderXM",
              mate: {
                title: "厦门民政工单派发"
              },
              component: () =>
                  import("../views/callCenter/detailsInfo/addReturn/civilOrderXM")
            },
            {
              path: "/civilOrder1",
              name: "civilOrder1",
              mate: {
                title: "民政工单派发"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/addReturn/civilOrder1")
            },
            {
              path: "/civilOrder2",
              name: "civilOrder2",
              mate: {
                title: "民政工单处理"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/addReturn/civilOrder2")
            },
            {
              path: "/civilOrder3",
              name: "civilOrder3",
              mate: {
                title: "民政工单回访"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/addReturn/civilOrder3")
            },
            {
              path: "/civilOrder4",
              name: "civilOrder4",
              mate: {
                title: "民政工单待作废"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/addReturn/civilOrder4")
            },
            {
              path: "/civilOrder5",
              name: "civilOrder5",
              mate: {
                title: "民政工单已完成"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/addReturn/civilOrder5")
            },
            {
              path: "/civilOrder6",
              name: "civilOrder6",
              mate: {
                title: "民政工单已作废"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/addReturn/civilOrder6")
            },
            {
              path: "/civilOrder7",
              name: "civilOrder7",
              mate: {
                title: "民政工单统计"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/addReturn/civilOrder7")
            },
            {
              path: "/civilOrder8",
              name: "civilOrder8",
              mate: {
                title: "民政工单查询"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/addReturn/civilOrder8")
            },
            {
              path: "/civilOrder9",
              name: "civilOrder9",
              mate: {
                title: "异常工单"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/addReturn/civilOrder9")
            }
            // {
            //   path: "/civilOrder10",
            //   name: "civilOrder10",
            //   mate: {
            //     title: "历史异常工单"
            //   },
            //   component: () =>
            //     import("../views/callCenter/detailsInfo/addReturn/civilOrder10")
            // }
          ]
        },
        {
          path: "/canlianReturn",
          name: "canlianReturn",
          mate: {
            title: "残联服务工单"
          },
          component: () =>
            import("../views/callCenter/detailsInfo/canlianReturn/index"),
          children: [
            {
              path: "/remnantOrder1",
              name: "remnantOrder1",
              mate: {
                title: "残联工单派发"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/canlianReturn/remnantOrder1")
            },
            {
              path: "/remnantOrder2",
              name: "remnantOrder2",
              mate: {
                title: "残联工单处理"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/canlianReturn/remnantOrder2")
            },
            {
              path: "/remnantOrder3",
              name: "remnantOrder3",
              mate: {
                title: "残联工单回访"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/canlianReturn/remnantOrder3")
            },
            {
              path: "/remnantOrder4",
              name: "remnantOrder4",
              mate: {
                title: "残联工单待作废"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/canlianReturn/remnantOrder4")
            },
            {
              path: "/remnantOrder5",
              name: "remnantOrder5",
              mate: {
                title: "残联工单已完成"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/canlianReturn/remnantOrder5")
            },
            {
              path: "/remnantOrder6",
              name: "remnantOrder6",
              mate: {
                title: "残联工单已作废"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/canlianReturn/remnantOrder6")
            },
            {
              path: "/remnantOrder7",
              name: "remnantOrder7",
              mate: {
                title: "残联工单查询"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/canlianReturn/remnantOrder7")
            }
          ]
        },
        {
          path: "/wenmingReturn",
          name: "wenmingReturn",
          mate: {
            title: "探访关爱服务工单"
          },
          component: () =>
            import("../views/callCenter/detailsInfo/wenmingReturn/index"),
          children: [
            {
              path: "/cultureOrder1",
              name: "cultureOrder1",
              mate: {
                title: "探访关爱工单待派发"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/wenmingReturn/cultureOrder1")
            },
            {
              path: "/cultureOrder2",
              name: "cultureOrder2",
              mate: {
                title: "探访关爱工单待处理"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/wenmingReturn/cultureOrder2")
            },
            {
              path: "/cultureOrder3",
              name: "cultureOrder3",
              mate: {
                title: "探访关爱工单待回访"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/wenmingReturn/cultureOrder3")
            },
            {
              path: "/cultureOrder4",
              name: "cultureOrder4",
              mate: {
                title: "探访关爱工单待作废"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/wenmingReturn/cultureOrder4")
            },
            {
              path: "/cultureOrder5",
              name: "cultureOrder5",
              mate: {
                title: "探访关爱工单已完成"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/wenmingReturn/cultureOrder5")
            },
            {
              path: "/cultureOrder6",
              name: "cultureOrder6",
              mate: {
                title: "探访关爱工单已作废"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/wenmingReturn/cultureOrder6")
            },
            {
              path: "/cultureOrder7",
              name: "cultureOrder7",
              mate: {
                title: "探访关爱工单查询"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/wenmingReturn/cultureOrder7")
            }
          ]
        },
        {
          path: "/shangyeReturn",
          name: "shangyeReturn",
          mate: {
            title: "商业服务工单"
          },
          component: () =>
            import("../views/callCenter/detailsInfo/shangyeReturn/index"),
          children: [
            {
              path: "/businessOrder1",
              name: "businessOrder1",
              mate: {
                title: "商业工单派发"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/shangyeReturn/businessOrder1")
            },
            {
              path: "/businessOrder2",
              name: "businessOrder2",
              mate: {
                title: "商业工单处理"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/shangyeReturn/businessOrder2")
            },
            {
              path: "/businessOrder3",
              name: "businessOrder3",
              mate: {
                title: "商业工单回访"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/shangyeReturn/businessOrder3")
            },
            {
              path: "/businessOrder4",
              name: "businessOrder4",
              mate: {
                title: "商业工单待作废"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/shangyeReturn/businessOrder4")
            },
            {
              path: "/businessOrder5",
              name: "businessOrder5",
              mate: {
                title: "商业工单已完成"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/shangyeReturn/businessOrder5")
            },
            {
              path: "/businessOrder6",
              name: "businessOrder6",
              mate: {
                title: "商业工单已作废"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/shangyeReturn/businessOrder6")
            },
            {
              path: "/businessOrder7",
              name: "businessOrder7",
              mate: {
                title: "商业工单统计"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/shangyeReturn/businessOrder7")
            },
            {
              path: "/businessOrder8",
              name: "businessOrder8",
              mate: {
                title: "商业工单查询"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/shangyeReturn/businessOrder8")
            }
          ]
        },
        {
          path: "/retiredReturn",
          name: "retiredReturn",
          mate: {
            title: "退役军人服务工单"
          },
          component: () =>
            import("../views/callCenter/detailsInfo/retiredReturn/index"),
          children: [
            {
              path: "/retireOrder1",
              name: "retireOrder1",
              mate: {
                title: "退役军人工单派发"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/retiredReturn/retireOrder1")
            },
            {
              path: "/retireOrder2",
              name: "retireOrder2",
              mate: {
                title: "退役军人工单处理"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/retiredReturn/retireOrder2")
            },
            {
              path: "/retireOrder3",
              name: "retireOrder3",
              mate: {
                title: "退役军人工单回访"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/retiredReturn/retireOrder3")
            },
            {
              path: "/retireOrder4",
              name: "retireOrder4",
              mate: {
                title: "退役军人工单待作废"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/retiredReturn/retireOrder4")
            },
            {
              path: "/retireOrder5",
              name: "retireOrder5",
              mate: {
                title: "退役军人工单已完成"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/retiredReturn/retireOrder5")
            },
            {
              path: "/retireOrder6",
              name: "retireOrder6",
              mate: {
                title: "退役军人工单已作废"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/retiredReturn/retireOrder6")
            },
            {
              path: "/retireOrder7",
              name: "retireOrder7",
              mate: {
                title: "退役军人工单统计"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/retiredReturn/retireOrder7")
            },
            {
              path: "/retireOrder8",
              name: "retireOrder8",
              mate: {
                title: "退役军人工单查询"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/retiredReturn/retireOrder8")
            }
          ]
        },
        {
          path: "/infoReturn",
          name: "infoReturn",
          mate: {
            title: "信息回访工单"
          },
          component: () =>
            import("../views/callCenter/detailsInfo/infoReturn/index"),
          children: [
            {
              path: "/infoOrder1",
              name: "infoOrder1",
              mate: {
                title: "信息工单派发"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/infoReturn/infoOrder1")
            },
            {
              path: "/infoOrder2",
              name: "infoOrder2",
              mate: {
                title: "信息工单处理"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/infoReturn/infoOrder2")
            },
            {
              path: "/infoOrder3",
              name: "infoOrder3",
              mate: {
                title: "信息工单回访"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/infoReturn/infoOrder3")
            },
            {
              path: "/infoOrder4",
              name: "infoOrder4",
              mate: {
                title: "信息工单待作废"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/infoReturn/infoOrder4")
            },
            {
              path: "/infoOrder5",
              name: "infoOrder5",
              mate: {
                title: "信息工单已完成"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/infoReturn/infoOrder5")
            },
            {
              path: "/infoOrder6",
              name: "infoOrder6",
              mate: {
                title: "信息工单已作废"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/infoReturn/infoOrder6")
            },
            {
              path: "/infoOrder7",
              name: "infoOrder7",
              mate: {
                title: "信息工单查询"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/infoReturn/infoOrder7")
            }
          ]
        },
        {
          path: "/jishengReturn",
          name: "jishengReturn",
          mate: {
            title: "计生卫计委服务工单"
          },
          component: () =>
              import("../views/callCenter/detailsInfo/jishengReturn/index"),
          children: [
            {
              path: "/jsOrder1",
              name: "jsOrder1",
              mate: {
                title: "计生卫计委服务派发"
              },
              component: () =>
                  import("../views/callCenter/detailsInfo/jishengReturn/jsOrder1")
            },
            {
              path: "/jsOrder2",
              name: "jsOrder2",
              mate: {
                title: "计生卫计委服务处理"
              },
              component: () =>
                  import("../views/callCenter/detailsInfo/jishengReturn/jsOrder2")
            },
            {
              path: "/jsOrder3",
              name: "jsOrder3",
              mate: {
                title: "计生卫计委服务回访"
              },
              component: () =>
                  import("../views/callCenter/detailsInfo/jishengReturn/jsOrder3")
            },
            {
              path: "/jsOrder4",
              name: "jsOrder4",
              mate: {
                title: "计生卫计委服务待作废"
              },
              component: () =>
                  import("../views/callCenter/detailsInfo/jishengReturn/jsOrder4")
            },
            {
              path: "/jsOrder5",
              name: "jsOrder5",
              mate: {
                title: "计生卫计委服务已完成"
              },
              component: () =>
                  import("../views/callCenter/detailsInfo/jishengReturn/jsOrder5")
            },
            {
              path: "/jsOrder6",
              name: "jsOrder6",
              mate: {
                title: "计生卫计委服务已作废"
              },
              component: () =>
                  import("../views/callCenter/detailsInfo/jishengReturn/jsOrder6")
            },
            {
              path: "/jsOrder7",
              name: "jsOrder7",
              mate: {
                title: "计生卫计委服务查询"
              },
              component: () =>
                  import("../views/callCenter/detailsInfo/jishengReturn/jsOrder7")
            }
          ]
        },
        {
          path: "/pingantongReturn",
          name: "pingantongReturn",
          mate: {
            title: "平安通服务工单"
          },
          component: () =>
              import("../views/callCenter/detailsInfo/pingantongReturn/index"),
          children: [
            {
              path: "/patOrder1",
              name: "patOrder1",
              mate: {
                title: "平安通服务派发"
              },
              component: () =>
                  import("../views/callCenter/detailsInfo/pingantongReturn/patOrder1")
            },
            {
              path: "/patOrder2",
              name: "patOrder2",
              mate: {
                title: "平安通服务处理"
              },
              component: () =>
                  import("../views/callCenter/detailsInfo/pingantongReturn/patOrder2")
            },
            {
              path: "/patOrder3",
              name: "patOrder3",
              mate: {
                title: "平安通服务回访"
              },
              component: () =>
                  import("../views/callCenter/detailsInfo/pingantongReturn/patOrder3")
            },
            {
              path: "/patOrder4",
              name: "patOrder4",
              mate: {
                title: "平安通服务待作废"
              },
              component: () =>
                  import("../views/callCenter/detailsInfo/pingantongReturn/patOrder4")
            },
            {
              path: "/patOrder5",
              name: "patOrder5",
              mate: {
                title: "平安通服务已完成"
              },
              component: () =>
                  import("../views/callCenter/detailsInfo/pingantongReturn/patOrder5")
            },
            {
              path: "/patOrder6",
              name: "patOrder6",
              mate: {
                title: "平安通服务已作废"
              },
              component: () =>
                  import("../views/callCenter/detailsInfo/pingantongReturn/patOrder6")
            },
            {
              path: "/patOrder7",
              name: "patOrder7",
              mate: {
                title: "平安通查询"
              },
              component: () =>
                  import("../views/callCenter/detailsInfo/pingantongReturn/patOrder7")
            }
          ]
        },
        {
          path: "/protectionInsurance",
          name: "protectionInsurance",
          mate: {
            title: "长护险服务工单"
          },
          component: () =>
            import("../views/callCenter/detailsInfo/protectionInsurance/index"),
          children: [
            {
              path: "/civilOrderXM",
              name: "civilOrderXM",
              mate: {
                title: "厦门长护险工单派发"
              },
              component: () =>
                  import("../views/callCenter/detailsInfo/protectionInsurance/dangerOrderXM")
            },
            {
              path: "/dangerOrder1",
              name: "dangerOrder1",
              mate: {
                title: "长护险工单派发"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/protectionInsurance/dangerOrder1")
            },
            {
              path: "/dangerOrder2",
              name: "dangerOrder2",
              mate: {
                title: "长护险工单处理"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/protectionInsurance/dangerOrder2")
            },
            {
              path: "/dangerOrder3",
              name: "dangerOrder3",
              mate: {
                title: "长护险工单回访"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/protectionInsurance/dangerOrder3")
            },
            {
              path: "/dangerOrder4",
              name: "dangerOrder4",
              mate: {
                title: "长护险工单待作废"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/protectionInsurance/dangerOrder4")
            },
            {
              path: "/dangerOrder5",
              name: "dangerOrder5",
              mate: {
                title: "长护险工单已完成"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/protectionInsurance/dangerOrder5")
            },
            {
              path: "/dangerOrder6",
              name: "dangerOrder6",
              mate: {
                title: "长护险工单已作废"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/protectionInsurance/dangerOrder6")
            },
            {
              path: "/dangerOrder7",
              name: "dangerOrder7",
              mate: {
                title: "长护险工单统计"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/protectionInsurance/dangerOrder7")
            },
            {
              path: "/dangerOrder8",
              name: "dangerOrder8",
              mate: {
                title: "长护险工单查询"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/protectionInsurance/dangerOrder8")
            },
            {
              path: "/dangerOrder9",
              name: "dangerOrder9",
              mate: {
                title: "异常工单"
              },
              component: () =>
                import("../views/callCenter/detailsInfo/protectionInsurance/dangerOrder9")
            }
          ]
        },
      ]
    },
    {
      path: "/updateInfo",
      name: "updateInfo",
      mate: {
        title: "话务统计"
      },
      component: () => import("../views/callCenter/updateInfo/index"),

      children: [
        {
          path: "/statistics",
          name: "statistics",
          mate: {
            title: "话务统计"
          },
          component: () => import("../views/callCenter/updateInfo/statistics")
        },
        {
          path: "/callInCount",
          name: "callInCount",
          mate: {
            title: "呼入电话统计"
          },
          component: () => import("../views/callCenter/updateInfo/callInCount")
        },
        {
          path: "/exhaleCount",
          name: "exhaleCount",
          mate: {
            title: "呼出电话统计"
          },
          component: () => import("../views/callCenter/updateInfo/exhaleCount")
        },
        {
          path: "/jinxian",
          name: "jinxian",
          mate: {
            title: "进线分时段统计"
          },
          component: () => import("../views/callCenter/updateInfo/jinxian")
        }
      ]
    },
    {
      path: "/healthy",
      name: "healthy",
      mate: {
        title: "通话记录"
      },
      component: () => import("../views/callCenter/healthy/index")
    },
    {
      path: "/settlementManage",
      name: "settlementManage",
      mate: {
        title: "工单结算管理"
      },
      component: () => import("../views/callCenter/settlementManage/index")
    },
    {
      path: "/addWorkOrder",
      name: "addWorkOrder",
      mate: {
        title: "联络历史"
      },
      component: () => import("../views/callCenter/addWorkOrder/index")
    },
    {
      path: "/workapplicationManage",
      name: "workapplicationManage",
      mate: {
        title: "工单申请管理"
      },
      component: () => import("../views/callCenter/workapplicationManage/list")
    },
    {
      path: "/liaison",
      name: "liaison",
      mate: {
        title: "漏接来电统计"
      },
      component: () => import("../views/callCenter/liaison/index")
    },
    {
      path: "/serviceRecord",
      name: "serviceRecord",
      mate: {
        title: "话务监管"
      },
      component: () => import("../views/callCenter/serviceRecord/index")
    },
    {
      path: "/locationInfo",
      name: "locationInfo",
      mate: {
        title: "话务小结"
      },
      component: () => import("../views/callCenter/locationInfo/index"),
      redirect: "/operator",
      children: [
        {
          path: "/operator",
          name: "operator",
          mate: {
            title: "话务小结统计"
          },
          component: () => import("../views/callCenter/locationInfo/operator")
        }
      ]
    },

    {
      path: "/trajectoryInfo",
      name: "trajectoryInfo",
      mate: {
        title: "质检管理"
      },
      component: () => import("../views/callCenter/trajectoryInfo/index"),
      redirect: "/trajectoryMange",
      children: [
        {
          path: "/trajectoryMange",
          name: "trajectoryMange",
          mate: {
            title: "质检管理"
          },
          component: () =>
            import("../views/callCenter/trajectoryInfo/trajectoryMange")
        },
        {
          path: "/trajectorySell",
          name: "trajectorySell",
          mate: {
            title: "质检派发"
          },
          component: () =>
            import("../views/callCenter/trajectoryInfo/trajectorySell")
        },
        {
          path: "/trajectoryVisit",
          name: "trajectoryVisit",
          mate: {
            title: "质检回访"
          },
          component: () =>
            import("../views/callCenter/trajectoryInfo/trajectoryVisit")
        }
      ]
    },
    // {
    // 	path: '/trajectoryInfo',
    // 	name: 'trajectoryInfo',
    // 	mate: {
    // 		title: '质检管理'
    // 	},
    // 	component: () => import("../views/callCenter/trajectoryInfo/index")
    // },
    {
      path: "/electronics",
      name: "electronics",
      mate: {
        title: "老人管理"
      },
      component: () => import("../views/callCenter/electronics/index")
    },
    {
      path: "/bigScreen",
      name: "bigScreen",
      mate: {
        title: "大屏展示"
      },
      component: () => import("../views/callCenter/bigScreen/index")
    },
    {
      path: "/callPackageType",
      name: "callPackageType",
      mate: {
        title: "套餐类型"
      },
      component: () =>
        import("../views/callCenter/callDictionary/callPackageType")
    },
    {
      path: "/callServiceCategory",
      name: "callServiceCategory",
      mate: {
        title: "服务类别"
      },
      component: () =>
        import("../views/callCenter/callDictionary/callServiceCategory")
    },
    {
      path: "/equipmentType",
      name: "equipmentType",
      mate: {
        title: "设备类型"
      },
      component: () =>
        import("../views/callCenter/callDictionary/equipmentType")
    },
    {
      path: "/trafficOpen",
      name: "trafficOpen",
      mate: {
        title: "沟通类型"
      },
      component: () => import("../views/callCenter/callDictionary/trafficOpen")
    },
    {
      path: "/todayTarget",
      name: "todayTarget",
      mate: {
        title: "今日目标"
      },
      component: () => import("../views/callCenter/callDictionary/todayTarget")
    },
    {
      path: "/learnType",
      name: "learnType",
      mate: {
        title: "学习培训"
      },
      component: () => import("../views/callCenter/callDictionary/learnType")
    },
    // 设备配置
    {
      path: "/deviceConfiguration",
      name: "deviceConfiguration",
      mate: {
        title: "设备配置"
      },
      component: () =>
        import("../views/callCenter/callDictionary/deviceConfiguration/index.vue")
    },
    {
      path: "/callServiceItems",
      name: "callServiceItems",
      mate: {
        title: "服务项目"
      },
      component: () =>
        import("../views/callCenter/callDictionary/callServiceItems")
    },
    {
      path: "/serviceStaff",
      name: "serviceStaff",
      mate: {
        title: "服务人员"
      },
      component: () =>
        import("../views/callCenter/detailsInfo/serviceStaff/index")
    },
    {
      path: "/lySafeness",
      name: "lySafeness",
      mate: {
        title: "服务人员"
      },
      component: () =>
          import("../views/callCenter/detailsInfo/lySafeness/index")
    },
    {
      path: "/agentCcontrol",
      name: "agentCcontrol",
      mate: {
        title: "服务人员"
      },
      component: () =>
        import("../views/callCenter/callDictionary/agentCcontrol")
    },
    {
      path: "/enhanceAction",
      name: "enhanceAction",
      mate: {
        title: "提升行动"
      },
      component: () =>
          import("../views/callCenter/detailsInfo/enhanceAction/index")
    },
    {
      path: "/capabilityAssessment",
      name: "capabilityAssessment",
      mate: {
        title: "能力评估"
      },
      component: () =>
          import("../views/callCenter/assessment/capabilityAssessment/index")
    },
    {
      path: "/serviceDemandAssessment",
      name: "serviceDemandAssessment",
      mate: {
        title: "服务需求评估"
      },
      component: () =>
          import("../views/callCenter/assessment/serviceDemandAssessment/index")
    }
  ]
}

export default callCenter
